import type { ReportTypeId } from '../config/reportTypes';
import { getSectionLabel } from '../config/reportSections';

/** Registry default label for a section on the given report type. */
export function defaultSectionHeading(
  sectionId: string,
  reportType: ReportTypeId | undefined | null,
  fallback: string,
): string {
  const label = getSectionLabel(sectionId, reportType ?? 'feasibility');
  return label !== sectionId ? label : fallback;
}
